export const optimizeImageUrl = ({
  url,
  width,
  height,
  crop,
  cfVariant = 'public',
}) => {
  if (!url) return url;

  /* ---------- Cloudinary ---------- */
  if (url.includes('res.cloudinary.com')) {
    // Avoid double transforms
    if (url.includes('/f_auto') || url.includes('/q_auto')) {
      return url;
    }

    const transformations = [
      'f_auto',
      'q_auto',
      width && `w_${width}`,
      height && `h_${height}`,
      crop && `c_${crop}`,
    ]
      .filter(Boolean)
      .join(',');

    return url.replace('/image/upload/', `/image/upload/${transformations}/`);
  }

  /* ---------- Cloudflare Images ---------- */
  if (url.includes('imagedelivery.net')) {
    // With a size, use a flexible variant so the CDN resizes (and serves
    // WebP/AVIF where supported) instead of sending the full original.
    const variant =
      width || height
        ? [
            width && `w=${width}`,
            height && `h=${height}`,
            'fit=scale-down',
            'format=auto',
          ]
            .filter(Boolean)
            .join(',')
        : cfVariant;
    // Replace last path segment with variant
    return url.replace(/\/[^/]+$/, `/${variant}`);
  }

  /* ---------- R2 (raw uploads, some 800 KB+) ---------- */
  // R2 can't resize, so route through Cloudflare Image Transformations once
  // it's enabled on the site's zone: set VITE_CF_IMAGE_RESIZE_ORIGIN
  // (e.g. https://smallsmall.com). Unset = original image, as before.
  const resizeOrigin = import.meta.env.VITE_CF_IMAGE_RESIZE_ORIGIN;
  if (resizeOrigin && width && url.includes('.r2.dev/')) {
    const options = [
      `width=${width}`,
      height && `height=${height}`,
      'fit=scale-down',
      'format=auto',
      'quality=80',
    ]
      .filter(Boolean)
      .join(',');
    return `${resizeOrigin}/cdn-cgi/image/${options}/${url}`;
  }

  /* ---------- Fallback ---------- */
  return url;
};
